// extracted by mini-css-extract-plugin
module.exports = {"assetPicker":"room__styles__assetPicker___24aok-"};